import { css } from 'styled-components';
import { cssVar } from 'src/app/styles/helper';

const primaryButtonStyles = css`
  background-color: ${cssVar('brand-500')};
  border: none;
  background-image: ${cssVar('gradient-linear-01')};
  color: ${cssVar('text-button-primary')};
  box-shadow: ${cssVar('shadow-xs-skeuomorphic')};

  &:hover {
    background-color: ${cssVar('bg-brand-solid-hover')};
    background-image: none;
  }

  &:focus {
    box-shadow: ${cssVar('shadow-focus-ring-xs-skeuomorphic')};
  }
`;

const secondaryButtonStyles = css`
  border: 1px solid ${cssVar('border-primary')};
  background: ${cssVar('bg-primary')};
  color: ${cssVar('text-secondary')};

  &:hover {
    background: ${cssVar('bg-primary-hover')};
  }

  &:focus {
    box-shadow: ${cssVar('shadow-focus-ring-xs-skeuomorphic')};
  }
`;

const tertiaryButtonStyles = css`
  background: transparent;
  border: none;
  color: ${cssVar('text-tertiary')};

  &:hover {
    background: ${cssVar('bg-primary-hover')};
  }

  &:focus {
    background: ${cssVar('bg-primary')};
    box-shadow: ${cssVar('shadow-focus-ring')};
  }
`;

const textLinkButtonStyles = css`
  background: transparent;
  border: none;
  color: ${cssVar('text-secondary')};
  padding: 0;
  border-radius: ${cssVar('radius-xs')};

  &:hover {
    text-decoration: underline;
  }

  &:focus {
    box-shadow: ${cssVar('shadow-focus-ring')};
  }
`;

const brandTextLinkStyles = css`
  ${textLinkButtonStyles}
  color: ${cssVar('text-brand-secondary')};

  &:hover {
    text-decoration: underline;
    color: ${cssVar('text-brand-secondary-hover')};
  }
`;

export const BUTTON_VARIANT_STYLES = {
  primary: primaryButtonStyles,
  secondary: secondaryButtonStyles,
  tertiary: tertiaryButtonStyles,
  'text-link': textLinkButtonStyles,
  'brand-text-link': brandTextLinkStyles,
};
